import { useStepState } from 'src/app/pages/startAPetition/pageContext';

import { SkipStep } from '../../SkipStep';

import { DescriptionLoader } from './DescriptionLoader';

export function DescriptionWrapper(): React.JSX.Element {
	const { data } = useStepState();
	const isSkipped = data.petition?.aiPromptChoice === 'ai';

	return isSkipped ? <SkipStep /> : <DescriptionLoader />;
}
